/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { UsageDto, UsageListItemDto } from './usage.dto';

export const UsageMapper = entity<UsageDto>();
export const UsageListItemMapper = entity<UsageListItemDto>();
